import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=45f736e6&scoped=true&lang=pug"
import script from "./SettingEdit.vue?vue&type=script&lang=ts"
export * from "./SettingEdit.vue?vue&type=script&lang=ts"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=45f736e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f736e6",
  null
  
)

export default component.exports